export default __webpack_public_path__ + "static/media/backgroundmobile.58dab82a.png";